import * as React from "react";
import type { SVGProps } from "react";
const SvgWalletOpenCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.667 3.334v13.333"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.417 7.916h1.25c.46 0 .834.373.834.833v2.5c0 .46-.373.834-.834.834h-1.25a2.083 2.083 0 0 1-2.083-2.084v0c0-1.15.933-2.083 2.083-2.083"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.667 12.084v2.5c0 1.15-.933 2.083-2.084 2.083h-10A2.083 2.083 0 0 1 2.5 14.584V5.417c0-1.15.933-2.083 2.083-2.083h10c1.15 0 2.084.933 2.084 2.083v2.5"
    />
  </svg>
);
export default SvgWalletOpenCheckmark;
